import { FileProperty } from "./FileProperty";

export class ImageProperty extends FileProperty {
  // TODO: eventually put validation ehre
}
